import classNames from 'classnames';

const SectionTitle = ({ children, className = '' }) => (
  <h3 className={classNames('text-title-20-bold mb-2 text-black-1', className)}>
    {children}
  </h3>
);

export default SectionTitle;
